import React from 'react';

import { cssMap } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { type ThirdPartyConfigsBootstrap } from '../../../constants/schemas/3p-config';
import { BannerPlacement, type useOAuthHandlers } from '../banner-placement';

import { QuickFindHeadlessPlacement } from './headless-placement';

const styles = cssMap({
	container: {
		paddingBottom: token('space.075'),
		paddingLeft: token('space.100'),
		paddingRight: token('space.100'),
	},
});

const PLACEMENT_ID = 'search-page-results-quick-find';

interface QuickFindBannerPlacementProps {
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
	availableProductsOrder: string[]; // Product keys in display order; connectors will be shown in this order
	useOAuthHandlers: useOAuthHandlers;
	onMessageViewed?: (trackImpression: () => void) => void;
}

export const QuickFindBannerPlacement = ({
	thirdPartyConfigs,
	availableProductsOrder,
	useOAuthHandlers,
	onMessageViewed,
}: QuickFindBannerPlacementProps): React.JSX.Element | null => {
	if (fg('post-office_enable_search-quick-find-headless')) {
		return (
			<QuickFindHeadlessPlacement
				placementId={PLACEMENT_ID}
				thirdPartyConfigs={thirdPartyConfigs}
				availableProductsOrder={availableProductsOrder}
				useOAuthHandlers={useOAuthHandlers}
				onMessageViewed={onMessageViewed}
			/>
		);
	}

	return (
		<Box xcss={styles.container}>
			<BannerPlacement
				placementId={PLACEMENT_ID}
				thirdPartyConfigs={thirdPartyConfigs}
				availableProductsOrder={availableProductsOrder}
				useOAuthHandlers={useOAuthHandlers}
				onMessageViewed={onMessageViewed}
			/>
		</Box>
	);
};
